import SingleDatePicker from './SingleDatePicker';

export default SingleDatePicker;